var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as cn from "classnames";
import * as moment from "moment";
import * as React from "react";
import Helmet from "react-helmet";
import * as Waypoint from "react-waypoint";
import * as styles from "./styles.css";
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import NewsList from "../newsList";
import { getImgixUrl } from "../../utils/getImgixUrl";
import Ad from "backpack-ui/dist/components/ad";
import Breadcrumbs from "backpack-ui/dist/components/breadcrumbs";
import Container from "backpack-ui/dist/components/container";
import GridColumn from "backpack-ui/dist/components/gridColumn";
import GridRow from "backpack-ui/dist/components/gridRow";
import { Heading } from "backpack-ui/dist/components/text";
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInfiniteScroll = function () {
            if (_this.state.posts.length) {
                _this.setState({
                    page: _this.state.page + 10,
                }, function () {
                    var morePosts = false;
                    _this.fetchData(morePosts);
                });
            }
        };
        _this.state = {
            isFetching: false,
            page: 0,
            posts: _this.props.posts,
        };
        return _this;
    }
    Category.prototype.updateInitialState = function () {
        window.__initialState.moreCategoryPosts = {
            posts: this.state.posts,
        };
    };
    Category.prototype.fetchData = function (morePosts) {
        return __awaiter(this, void 0, void 0, function () {
            var response, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                        });
                        return [4 /*yield*/, fetch("/blog/api/categories?categoryId=" + this.props.category.id + "&page=" + this.state.page)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        payload = _a.sent();
                        if (morePosts) {
                            window.scrollTo(0, 0);
                            this.setState({
                                isFetching: false,
                                page: this.state.page + 10,
                                posts: payload,
                            }, function () { return _this.updateInitialState(); });
                        }
                        else {
                            this.setState({
                                isFetching: false,
                                posts: this.state.posts.concat(payload),
                            }, function () { return _this.updateInitialState(); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Category.prototype.render = function () {
        var _a = this.props, posts = _a.posts, category = _a.category;
        return (React.createElement("div", { className: "category" },
            React.createElement(DataLayer, { data: {
                    cd7_Topic: "blog",
                    page_type: "blog-category-page",
                    site_section: "blog",
                } }),
            React.createElement(Helmet, null,
                React.createElement("title", null, category ? category.name + " – Lonely Planet's travel blog"
                    : "Latest – Lonely Planet's travel blog"),
                React.createElement("meta", { name: "title", content: category ?
                        category.name + " – Lonely Planet's travel blog" :
                        "Latest – Lonely Planet's travel blog" }),
                React.createElement("meta", { name: "description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                React.createElement("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                React.createElement("meta", { property: "og:title", content: category ?
                        category.name + " – Lonely Planet's travel blog" :
                        "Latest – Lonely Planet's travel blog" }),
                React.createElement("meta", { property: "og:description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                React.createElement("meta", { property: "og:image", content: "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
                React.createElement("meta", { name: "twitter:site", content: "@lonelyplanet" })),
            React.createElement(Container, { className: styles.categoryMargin },
                React.createElement(Breadcrumbs, { links: [
                        { title: "Blog", href: "/blog" },
                        {
                            href: category ? "/blog/category/" + category.slug : "/blog/latest",
                            title: category ? "" + category.name : "Latest",
                        },
                    ] }),
                React.createElement(GridRow, { className: styles.categoryMargin },
                    React.createElement(GridColumn, { sm: 12, className: styles.centerHeading },
                        React.createElement(Heading, { level: 1, weight: "medium", size: 3 }, category ? category.name : "Latest")),
                    React.createElement(GridColumn, { className: cn("Category", styles.categoryMargin), sm: 12, md: 7, lg: 6, lgShift: 1, fluid: true },
                        React.createElement(NewsList, { newsItems: this.state.posts.map(function (cat) { return ({
                                category: "" + cat.categories[0].name,
                                categoryLink: "/blog/category/" + cat.categories[0].slug,
                                link: "/blog/" + moment(cat.publicationDate).format("YYYY/MM/DD") + ("/" + cat.metadata.slug),
                                thumbnail: getImgixUrl(cat.featuredImage ?
                                    cat.featuredImage.url + "?auto=format&fit=crop&w=110&h=110&q=72" :
                                    // tslint:disable-next-line:max-line-length
                                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=110&h=110&q=72"),
                                title: "" + cat.title,
                            }); }) }),
                        React.createElement(Waypoint, { onEnter: this.handleInfiniteScroll })),
                    React.createElement(GridColumn, { sm: 12, md: 4, mdShift: 1, lg: 3, lgShift: 1, className: cn("categoryAds", styles.categoryAds), fluid: true },
                        React.createElement(Ad, { className: "CategoryAds", id: "ad-list-right-rail", framed: true }))))));
    };
    return Category;
}(React.Component));
export { Category };



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/category/index.tsx
// module id = BZ1W
// module chunks = 3